import React from "react";
import CurrencyFormat from "react-currency-format";
import { Segment, Header } from "semantic-ui-react";

interface ICurrentBalance {
  balance: number;
  hideBalance?: boolean;
}

export const CurrentBalance = ({ balance, hideBalance = false }: ICurrentBalance) => {
  return (
    <>
      <Segment padded className='public-portal-grid-segment'>
        <Header as='h2'>Current Balance</Header>
        <div style={{ display: "flex", justifyContent: "center", padding: "36px" }}>
          <CurrencyFormat
            value={hideBalance ? 0 : balance || 0}
            fixedDecimalScale={true}
            decimalScale={2}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
            style={{ fontWeight: "bold", fontSize: 60 }}
          />
        </div>
      </Segment>
    </>
  );
};
